import React, {useState} from 'react';
import styled from 'styled-components';
import {useDispatch, useSelector} from 'react-redux';
import Dropdown from 'react-bootstrap/Dropdown';
import {StyledID, StyledName, tabletWidth} from '../../mixins';
import {ArrowDown} from '../../UI/Icons';
import {formatID} from '../../common/helper';
import {selectActiveCircle, setActiveCircle} from './dashboardSlice';
import {circlesByID, ORMCircles} from '../../app/models/ormSelectors';

const StyledDropdown = styled(Dropdown)`
  position: relative;
  z-index: 1600;

  * {
    position: relative;
    z-index: 1600;
  }
`

const StyledToggle = styled(Dropdown.Toggle)`
  width: fit-content;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  background-color: transparent;
  border: none;
  margin-left: 8px;

  svg {
    margin: 0;
    transform: ${props => props.open ? 'rotate(180deg)' : 'none'};
    transition: transform 0.2s ease-out;
  }

  &::after {
    content: none;
  }
`

const StyledList = styled(Dropdown.Menu)`
   width: 90vw;
   max-width: 320px;
   height: auto;
   background: #FFFFFF;
   border: none;
   box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.08), 16px 16px 16px rgba(97, 119, 122, 0.08);
   border-radius: 20px;
   padding: 0;
   overflow: hidden;
   transform: translate3d(0, 59px, 0px) !important; 

  @media screen and (max-width: ${tabletWidth}) {
    transform: translate3d(-10%, 59px, 0px) !important;
  }
`

const StyledItem = styled(Dropdown.Item)`
  width: 100%;
  padding: 16px 24px;
  text-decoration: none;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    background-color: #E9E9E9;
    color: #848484;
  }
`

const CirclesDropdown = () => {
    const [open, setOpen] = useState(false);
    const ormCircles = useSelector(ORMCircles);
    const activeCircle = useSelector(selectActiveCircle);
    const circleByID = useSelector(circlesByID);
    const dispatch = useDispatch();

    const onItemClick = id => {
        dispatch(setActiveCircle(id));
    }

    const onToggle = () => {
        setOpen(prevState => !prevState);
    }


    return (
        <StyledDropdown show={open} onToggle={onToggle}>
                <StyledToggle open={open} id="dropdown-basic">
                    <StyledName>{circleByID(activeCircle)?.name}</StyledName>
                    {ArrowDown}
                </StyledToggle>
            <StyledList id="dropdown-menu">
                {ormCircles.map((item, i) => {
                    return (
                        <StyledItem key={i} onClick={() => onItemClick(item.id)} href="#">
                            <StyledName>{item.name}</StyledName>
                            <StyledID>{`ID: ${formatID(item.pin)}`}</StyledID>
                        </StyledItem>
                    )
                })}
            </StyledList>
        </StyledDropdown>
    )
};

export default CirclesDropdown;